import {
  Target,
  Mountain,
  Layers,
  LineChart,
  Bot,
  ShieldAlert,
  CalendarCheck,
  Shuffle,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import { STRATEGIES } from "../../data/content";
import "./StrategiesPage.css";

const ICONS = {
  Target,
  Mountain,
  Layers,
  LineChart,
  Bot,
  ShieldAlert,
  CalendarCheck,
  Shuffle,
};

const DETAILS = {
  "Goal-Based Investing":
    "We quantify each goal — corpus, timeline, and inflation — then build SIPs and asset mixes that stay on track through life stages.",
  "Long-Term Wealth Creation":
    "Quality equity and multi-asset allocation designed for compounding. We avoid short-term noise and stay invested with discipline.",
  "Mutual Fund Strategy":
    "Category weights, AMC quality, expense ratios, and consistency of returns guide shortlisting — with periodic rebalancing vs benchmarks.",
  "Equity Portfolio Strategy":
    "Fundamentals, valuation, and risk-reward drive stock selection. Position sizing and predefined exits protect capital.",
  "Algo Trading Strategy":
    "Rules-based systems with backtests, drawdown controls, and transparent reporting — emotion out, process in.",
  "Risk Management Framework":
    "Every portfolio carries a risk score, diversification rules, and drawdown thresholds reviewed with you regularly.",
  "Quarterly Portfolio Review":
    "Structured check-ins cover performance, tax harvesting, goal drift, and rebalancing recommendations.",
  "Diversification Strategy":
    "Spread risk across equity, debt, gold, and alternatives so no single market event defines your outcome.",
};

export default function StrategiesPage() {
  return (
    <div className="strategies-page">
      <PageHero
        badge="Strategies"
        title="Process-driven investing frameworks"
        subtitle="Clear philosophies for goals, wealth creation, mutual funds, equity, algo trading, and risk — designed for Indian investors."
        actions={[
          { label: "Review My Portfolio", to: "/portfolio-review", primary: true },
          { label: "Book Consultation", to: "/contact" },
        ]}
      />

      <section className="pm-section strategies-section">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            How We Invest
          </span>
          <h2 className="pm-section-title">Our investment strategies</h2>
          <p className="pm-section-sub">
            Goals first. Risk second. Products third — frameworks you can
            understand and stick with.
          </p>

          <div className="strategies-grid">
            {STRATEGIES.map((s) => {
              const Icon = ICONS[s.icon] || Target;
              return (
                <article key={s.title} className="pm-card strategies-card">
                  <div className="strategies-card__icon">
                    <Icon size={24} />
                  </div>
                  <h3>{s.title}</h3>
                  <p className="strategies-card__desc">{s.desc}</p>
                  <p className="strategies-card__detail">
                    {DETAILS[s.title] || s.desc}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand
        title="Want a strategy built around your goals?"
        subtitle="Share your goals and risk profile — we'll recommend a clear path forward."
        primary={{ label: "Review My Portfolio", to: "/portfolio-review" }}
        secondary={{ label: "Book Free Consultation", to: "/contact" }}
      />
    </div>
  );
}
